export default __webpack_public_path__ + "static/media/main-logo-2.8bec1437.png";